import { Routes } from '@angular/router';

export const configurationPanelRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./configuration-panel').then((m) => m.ConfigurationPanel),
      },
      {
        path: 'financial',
        loadComponent: () =>
          import('./financial/financial').then((m) => m.Financial),
      },
      {
        path: 'rules',
        loadComponent: () =>
          import('./rules-and-limits/rules-and-limits').then((m) => m.RulesAndLimits),
      },
      {
        path: 'expiry',
        loadComponent: () =>
          import('./time-and-expiry/time-and-expiry').then((m) => m.TimeAndExpiry),
      },
       
    ],
  },
];
